import React from "react";

import TextField from "@material-ui/core/TextField";
import { Field, useField } from "formik";

import themeKym from "../../utils/themes/ThemeKym";

const Code = ({ props }) => {
  const classesKym = themeKym();
  const [field] = useField(props.name);

  const configTextfield = {
    ...field,
    label: props.label,
    placeholder: props.placeholder,
    maxLength: props.maxLength,
    minLength: props.minLength,
  };

  const mask = (e) => {
    let x = e.target.value.replace(/\D/g, "").match(/(\d{0,3})/);
    e.target.value = x[1] !== "" ? "(" + x[1] + ")" : "";
    field.onBlur(e);
    field.onChange(e);
  };

  const onlyNumbers = (e) => {
    let x = e.target.value;
    x = x.replace(/\D/g, "");

    if (x.length > 10) {
      e.target.value = x.slice(0, 3);
    } else {
      e.target.value = x;
    }
    field.onChange(e);
  };

  configTextfield.value = configTextfield.value ?? "";
  if (props.material) {
    return (
      <TextField
        className={classesKym[`${props.className}`]}
        data-testid={`${props.id}-${props.className}`}
        {...configTextfield}
        variant="outlined"
        onChange={(e) => onlyNumbers(e)}
        onBlur={(e) => mask(e)}
        inputProps={{ minLength: props.minLength, maxLength: props.maxLength }}
      />
    );
  } else {
    return <Field className="lada" {...configTextfield} onChange={(e) => onlyNumbers(e)} onBlur={(e) => mask(e)} />;
  }
};
export default Code;
